import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type { Args as BaseArgs } from 'webapp/components/templates/public/recommended-boards';
import TemplatesPublicRecommendedBoardsComponent from 'webapp/components/templates/public/recommended-boards';
import { FlexContextSize } from 'webapp/components/templates/recommended-base';

import type SourceType from 'webapp/models-custom/source-type';
import type Template from 'webapp/models-custom/template';

interface Args extends BaseArgs {
	sourceType: SourceType;
}

export default class TemplatesPublicPopularBoardsComponent<
	T extends Args,
> extends TemplatesPublicRecommendedBoardsComponent<T> {
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;

	override linkText = 'Browse all templates >';
	override size = FlexContextSize.SMALL_BOARD;
	override typeClass = 'popular';

	override get title() {
		return 'Popular templates';
	}

	override get model(): Template[] {
		const sourceType = this.args.sourceType;
		return this.mmTemplatesService.popularBoardPublicTemplateModels
			.filter((template) => template.specificSourceTypesKeys.includes(sourceType.key))
			.slice(0, 3);
	}
}
